import React from "react";
import { Plus, Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";

export const SuppliersFiltersBar = ({ statusFilter, setStatusFilter, q, setQ, onAddSupplier }) => (
  <div className="flex items-center justify-between flex-wrap gap-3 mb-4">
    <Tabs value={statusFilter} onValueChange={setStatusFilter}>
      <TabsList>
        <TabsTrigger data-testid="suppliers-tab-all" value="all">All</TabsTrigger>
        <TabsTrigger data-testid="suppliers-tab-active" value="active">Active</TabsTrigger>
        <TabsTrigger data-testid="suppliers-tab-inactive" value="inactive">Inactive</TabsTrigger>
      </TabsList>
    </Tabs>
    <div className="flex items-center gap-2">
      <div className="relative">
        <Search className="h-4 w-4 absolute left-2.5 top-2.5 text-muted-foreground" />
        <Input data-testid="suppliers-search-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search suppliers..." className="pl-8 w-56" />
      </div>
      <Button data-testid="supplier-add-button" onClick={onAddSupplier} className="gap-2"><Plus className="h-4 w-4" /> Add Supplier</Button>
    </div>
  </div>
);
